/* eslint-disable no-unsafe-optional-chaining */
import { useContext, useState, useEffect, useRef } from 'react'
import { Form } from '@unform/web'
import {
  Toggle,
  ButtonNext,
  Path,
  MaskedInput2,
  Select2,
} from 'components/index'
import { UserContext } from 'context/userContext'
import { useFetch, useStorage } from 'hooks'
import * as Yup from 'yup'
import { numberToMoney, dateToTimestamp, optionsLevels } from 'helper/utils'
import { selectOptions, schemaNewCaption } from './factory'
import CaptionType from './CaptionType'
import { Bonus, CondicaoRenta, InfoContrato, InfoProduto } from './CaptionData'
import { Container } from './style'
import Retroativos from './Retroativos'

interface ValidationErrors {
  [key: string]: string
}
// setLocale({
//   mixed: {
//     default: 'Não é válido',
//   },
//   array: {
//     min: 'Selecione pelo menos ${min} cliente',
//   },
// })

export default function NovaCaptacao() {
  const {
    setPage,
    data,
    setData,
    toggleCap,
    setToggleCap,
    setRetroData,
    checkbox,
    radioBtnValue,
    requestFn,
    feedback,
    page,
  } = useContext(UserContext)
  const formRef = useRef<HTMLFormElement | any>(null)
  const api = useFetch()
  const form: any = new FormData()
  const [user] = useStorage('User')
  const [options, setOptions] = useState<any>([
    ['Proposta base', 'Proposta base'],
    ['Proposta personalizada', 'Proposta personalizada'],
    // ['Investimento realizado', 'Investimento realizado'],
  ])
  const [isCaptationsSelected, setIsCaptationsSelected] = useState(false)
  const [isEnpreendimentoSelected, setIsEnpreendimentoSelected] =
    useState(false) // Monitora se há um valor selecionado em "empreendimento" ou "captations"
  const [bonusCheckbox, setBonusCheckbox] = useState(false)

  const isPersonal = toggleCap === 'Proposta personalizada'
  const forOneClient = radioBtnValue === 'Selecionar cliente'
  const bigTitle = isPersonal
    ? 'Nova Proposta Personalizada'
    : toggleCap === 'Investimento realizado'
    ? 'Novo investimento realizado'
    : 'Nova captação'
  const notUperLevel = !['OWNER', 'DIRECTOR'].includes(
    optionsLevels[user.level]
  )

  useEffect(() => {
    setData({})
    setRetroData({})
    // setCheckbox(false)
    // if (formRef.current) {
    //   formRef.current.setData({
    //     amount: '',
    //     value: '',
    //     name: '',
    //     shortName: '',
    //     tick: '',
    //     type: null,
    //     guaranteeList: null,
    //     paymentType: null,
    //     profitability: '',
    //     IRType: null,
    //     cotizationIn: null,
    //     cotizationOut: null,
    //     isCotizationProfitable: null,
    //     recurrencyType: null,
    //     principalLiquidityType: null,
    //     deadline: null,
    //     short: '',
    //     quotaValue: '',
    //   })
    // }
  }, [toggleCap])

  const getCotas = () => {
    if (Number.isNaN((data?.amount * data?.value) / data?.quotaValue)) {
      return {
        meta: undefined,
      }
    }
    return {
      meta: data?.maxSupply * data?.quotaValue,
    }
  }

  // FORMATA O DATA PARA PEGAR SO O VALUE DE CHAVES SELECT
  // ex:  type: { label: 'Cotas imobiliárias', value: 'SPE' } para { type: 'SPE' }
  const extractValues = (obj: any) => {
    if (!obj) return {}
    const extractedObj: any = {}

    Object.entries(obj).forEach(([key, value]: any) => {
      if (!value) return
      if (typeof value === 'object' && 'value' in value) {
        extractedObj[key] = value.value
      } else {
        extractedObj[key] = value
      }
    })

    return extractedObj
  }

  // AQUI SETA A CALLBACK DE POST PARA CRIAR NOVA CAPTACAO
  const setCallbackForCreate = () => {
    const dates = {
      releaseAt: dateToTimestamp(data?.releaseAt),
      startedAt: dateToTimestamp(data?.startedAt),
      tradeAt: dateToTimestamp(data?.tradeAt),
      createdAt: dateToTimestamp(data?.createdAt),
    }

    if (isPersonal) {
      delete dates.releaseAt
    }

    let formatedData = {
      ...extractValues(data),
      ...dates,
      // bonus: [data.bonusMonths.value, data.profitabilityBonus],
      color: ['#DF7A58', '#DF7A58'],
      guaranteeList:
        Array.isArray(data?.guaranteeList) &&
        data.guaranteeList.some((v: any) => v.value === 'Não possui')
          ? ['Não possui']
          : data?.guaranteeList?.map((v: any) => v.value),
    }

    if (data.profitabilityBonus) {
      formatedData = {
        ...formatedData,
        bonus: [
          Number(data.bonusMonths.value),
          Number(data.profitabilityBonus),
        ],
      }
    }
    Object.entries(formatedData).forEach(([key, value]: any) => {
      if (typeof value === 'object') value = JSON.stringify(value)
      else if (!value) return
      form.set(key, value)
    })

    feedback.current = { title: 'Captação criada!', error: false }

    form.delete('releaseAt')

    requestFn.current = async () => {
      try {
        const response: any = await api.fetch('post', form, '/token', {
          'Content-type': 'multipart/form-data',
        })
        return response
      } catch (err: any) {
        console.error('err', err)
        return err
      }
    }
  }

  useEffect(() => {
    if (!isPersonal) {
      setBonusCheckbox(false)
    }
  }, [toggleCap])
  // Se o não Proposta personalizada for true, o bonusCheckbox é setado para false para não ser validado no yup

  useEffect(() => {
    formRef.current.setErrors({})
  }, [data.enterpriseId, data.captationsId])
  // Reseta os erros do YUP quando o usuário seleciona um novo empreendimento ou captação

  const handleSubmit = async () => {
    try {
      // Remove all previous errors
      formRef.current.setErrors({})
      setCallbackForCreate()

      const formatedData = {
        ...extractValues(data),
      }

      await schemaNewCaption({
        formatedData,
        rule: isPersonal,
        bonus: bonusCheckbox,
        toggleCap,
      }).validate(data, { abortEarly: false })

      setPage(1)
    } catch (err) {
      console.error(err)
      const validationErrors: ValidationErrors = {}
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            validationErrors[error.path] = error.message
          }
        })
        console.error('Validations', validationErrors)
        formRef.current.setErrors(validationErrors)
      }
    }
  }

  const isDisabled = () => {
    if (notUperLevel) return false
    if (checkbox) return !(isCaptationsSelected || isEnpreendimentoSelected)
    if (!checkbox) return false
  }

  return (
    <Container>
      <Path className="path" data-testid="modal-path">
        <span className="path">
          {'Gestão de produtos >  Investimentos  > Nova captação'}
        </span>
      </Path>
      <div>
        <h1 className="new-token-title">{bigTitle}</h1>
        <div className="new-token-toggle">
          <Toggle
            toggle={toggleCap}
            setToggle={setToggleCap}
            options={options}
          />
        </div>

        {toggleCap === 'Investimento realizado' ? (
          <Retroativos toggleCap={toggleCap} />
        ) : (
          <Form ref={formRef} onSubmit={() => console.log('submit')}>
            <CaptionType
              setOptions={setOptions}
              setIsCaptationsSelected={setIsCaptationsSelected}
              setIsEnpreendimentoSelected={setIsEnpreendimentoSelected}
            />

            <InfoProduto toggleCap={toggleCap} />

            <div className="new-token-subtitle">
              <h4>Condiçōes da captação</h4>
            </div>

            <div className="new-token-container">
              <MaskedInput2
                disabled
                dataTestId="quota-price"
                type="text"
                large
                handleChange={(e: any) => console.log(e)}
                placeholder="Preço da cota"
                name="price"
                defaultValue={
                  data?.quotaValue && `R$ ${numberToMoney(data?.quotaValue)}`
                }
              />

              <MaskedInput2
                type="money"
                hasAsterisk
                large
                dataTestId="investiment-input"
                handleChange={(e: any) => {
                  // console.log(e)
                  const newMinInvest = e
                  const updatedData = {
                    minInvest: newMinInvest,
                    maxSupply: data?.maxSupply,
                  }

                  if (isPersonal && forOneClient) {
                    updatedData.maxSupply = newMinInvest / data?.quotaValue
                  }

                  setData((oldValue: any) => ({
                    ...oldValue,
                    ...updatedData,
                  }))
                }}
                placeholder={
                  isPersonal && forOneClient
                    ? 'Valor do investimento'
                    : 'Investimento mínimo'
                }
                name="minInvest"
                defaultValue={data?.minInvest}
                disabled={isDisabled()}
              />
              <MaskedInput2
                disabled
                type="text"
                placeholder="Meta da captação"
                name="maxSupply2"
                large
                dataTestId="fundraising-goal"
                defaultValue={
                  !getCotas()?.meta
                    ? undefined
                    : `R$ ${numberToMoney(Number(getCotas()?.meta))}`
                }
              />
              {forOneClient && isPersonal ? (
                <MaskedInput2
                  hasAsterisk
                  type="text"
                  disabled
                  handleChange={(e: any) => {
                    console.log(e)
                  }}
                  large
                  dataTestId="quota-amount"
                  placeholder="Quantidade de cotas"
                  name="maxSupply"
                  defaultValue={data?.maxSupply}
                />
              ) : (
                <MaskedInput2
                  hasAsterisk
                  type="number"
                  large
                  dataTestId="quota-amount"
                  handleChange={(e: any) => {
                    const newMaxSupply = Number(e)
                    const updatedData = {
                      maxSupply: newMaxSupply,
                      minInvest: data?.minInvest,
                    }

                    if (isPersonal && forOneClient) {
                      updatedData.minInvest =
                        newMaxSupply * (data?.quotaValue || 1)
                    }

                    setData((oldValue: any) => ({
                      ...oldValue,
                      ...updatedData,
                    }))
                  }}
                  placeholder="Quantidade de cotas"
                  name="maxSupply"
                  defaultValue={data?.maxSupply}
                />
              )}
              <MaskedInput2
                disabled
                dataTestId="available-quotas"
                type="number"
                large
                handleChange={(e: any) => console.log(e)}
                placeholder="Cotas disponiveis do empreendimento"
                name="totalAvailable"
                defaultValue={checkbox ? data?.totalAvailable : data?.available}
              />
              {checkbox && (
                <MaskedInput2
                  disabled
                  dataTestId="available-quotas"
                  hasAsterisk
                  type="number"
                  large
                  handleChange={(e: any) => console.log(e)}
                  placeholder="Cotas disponiveis para esta captação"
                  name="available"
                  defaultValue={data?.available}
                />
              )}
              <Select2
                hasAsterisk
                placeholder="Período de captação"
                name="icoPeriod"
                dataTestId="captation-period-select"
                large
                options={
                  !isPersonal
                    ? selectOptions.icoDays
                    : selectOptions.icoDaysPersonal
                }
                onChange={(e: any) => {
                  setData((oldValue: any) => ({
                    ...oldValue,
                    icoPeriod: e,
                  }))
                }}
                value={data?.icoPeriod}
                disabled={isDisabled()}
              />
            </div>

            <InfoContrato
              isCaptationsSelected={isCaptationsSelected}
              isEnpreendimentoSelected={isEnpreendimentoSelected}
            />

            {!isPersonal && (
              <>
                <div className="new-token-subtitle">
                  <h4>Data</h4>
                </div>
                <div className="new-token-container">
                  <MaskedInput2
                    large
                    hasAsterisk
                    dataTestId="start-date-input"
                    type="date"
                    handleChange={(e: any) => {
                      setData((oldValue: any) => ({
                        ...oldValue,
                        releaseAt: e.target.value,
                      }))
                    }}
                    placeholder="Data de Lançamento"
                    name="releaseAt"
                    defaultValue={data?.releaseAt}
                    disabled={notUperLevel}
                  />
                </div>
              </>
            )}

            <CondicaoRenta
              isCaptationsSelected={isCaptationsSelected}
              isEnpreendimentoSelected={isEnpreendimentoSelected}
            />

            {isPersonal && (
              <Bonus
                checkbox={bonusCheckbox}
                setCheckbox={setBonusCheckbox}
                isCaptationsSelected={isCaptationsSelected}
                isEnpreendimentoSelected={isEnpreendimentoSelected}
              />
            )}
            <ButtonNext
              data-testid="next-button"
              isAdvance={page === 0}
              advancePage={() => handleSubmit()}
            />
          </Form>
        )}
      </div>
    </Container>
  )
}
